import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {DetalleInmuebleService} from '../../services/detalle-inmueble.service';
import { ActivatedRoute, Router } from '@angular/router';
import {DetalleInmuebleModel} from '../../models/detalle-inmueble.model';
import { PlatformLocation } from '@angular/common';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {RecomendarInmuebleService} from '../../services/recomendar-inmueble.service';
import {RecomendarInmuebleModel} from '../../models/recomendar-inmueble.model';
import {ValidadoresCazaOportunidadService} from '../../services/validadoresCazaOportunidad.service';
import { NotificacionInmueble } from '../../models/InmuebleSearch.model.response';
import { InmuebleResponse } from '../../models/InmueblesResponse';
import { saveAs } from 'file-saver';
import { ChangeDetectorRef } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { OpExitosaModalComponent } from '../op-exitosa-modal/op-exitosa-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Lightbox, LightboxConfig, LightboxEvent, LightboxModule } from 'ngx-lightbox';
import { IAlbum } from 'ngx-lightbox';
import { LightboxWindowRef } from 'ngx-lightbox/lightbox-event.service';
import { LightboxComponent } from 'ngx-lightbox/lightbox.component';
import { LightboxOverlayComponent } from 'ngx-lightbox/lightbox-overlay.component';


@Component({
    selector: 'app-detalle-inmueble',
    templateUrl: './detalle-inmueble.component.html',
    styleUrls: ['./detalle-inmueble.component.css'],
    imports: [LightboxComponent, LightboxOverlayComponent],
    providers: [Lightbox, LightboxConfig, LightboxEvent, LightboxWindowRef, LightboxModule, LightboxComponent, LightboxOverlayComponent],
    standalone: false
})
export class DetalleInmuebleComponent implements OnInit {
  @ViewChild('shareModal') shareModal!: ElementRef;
    @ViewChild('recomendarModal') recomendarModal!: ElementRef;

  /*
  * Variables para controlar la visibilidad del mapa
  * */
  lat: number;
  lng: number;
  zoom: number = 15;
  folio: string;
  direccion = '';
  buscar:any;
  center: google.maps.LatLngLiteral;
  visible:boolean =false;
  mapOptions: google.maps.MapOptions = {
    mapTypeControl: true,
    mapTypeControlOptions: {
      mapTypeIds: ['roadmap', 'satellite'],
      style: google.maps.MapTypeControlStyle.DEFAULT
    }
  };
  /*
  * Booleanos para controlar cuando se vana a mostrar los mensajes de error
  * */
  detalleExiste: boolean;
  mapaCargado: boolean;
  mapError = { cabecera: '', mensaje: ''};
  detalleError = {cabecera: '', mensaje: ''};

  detalle: DetalleInmuebleModel;
  cargandoFicha = false;

  //formulario recomendar a un amigo
  formRecomendar!: UntypedFormGroup;
  recomendarDto: RecomendarInmuebleModel = new RecomendarInmuebleModel();
  mostrarFormRecomendarInmueble: boolean;
  mostrarBtnCerrarModal: boolean;
  confModalRecomendar = {titulo: "", mensajeHeader: "", mensajeFooter: "", logo: "", colorLogo: ""};

  album: IAlbum[] = [];

/*
* variable para notificacion inmueble
*/
formNotificacion = UntypedFormGroup;
payLoadNotificacion: NotificacionInmueble = new NotificacionInmueble();

CANCELAR = 'Cancelar';
ACEPTAR = 'Aceptar';
ENVIAR = 'Enviar';
OK = 'OK';
CODERROR = 'ERR-004';
lblBtnCerrarModal = 'Cancelar';
notificacionModel: NotificacionInmueble = new NotificacionInmueble();
mensajeValidacionEmail: string;
procesandoNotificacion = false;
notificacionGuardada = false;
notificacionFallida = false;
paginaActual:number;
confModal = {titulo: '', mensajeHeader: '', mensajeFooter: '', logo: '', colorLogo: ''};
estatusOps = ["En regularización","Comercializable"];
precioEnActualizacion = 'En actualización';
listo: boolean = false;
error: boolean = false;

imagenes: string[] = [];

gruposImagenes: string[][] = [];

  constructor(private detalleService: DetalleInmuebleService,
              private activatedRoute: ActivatedRoute,
              private validarores: ValidadoresCazaOportunidadService,
              private location: PlatformLocation,
              private routes: Router,
              private formBuilder: UntypedFormBuilder,
              private recomendarService: RecomendarInmuebleService,
              private validadores: ValidadoresCazaOportunidadService,
              private cdr: ChangeDetectorRef,
              private dialog: MatDialog,
              private lightbox: Lightbox
              ) {
              this.crearFormRecomendar();
              this.crearFormularioNotificacion();
              this.activatedRoute.queryParams.subscribe( params => {
                this.paginaActual = +params.page;
              })
              /*this.location.onPopState(() => {
                this.routes.navigate(['/inmuebles/page/'+this.paginaActual], {queryParams : {buscar: btoa(JSON.stringify(this.buscar))}, relativeTo: this.activatedRoute});
              });*/
  }

  ngOnInit() {
    this.lblBtnCerrarModal = this.CANCELAR;
    this.mostrarBtnCerrarModal = true;
    this.mostrarFormRecomendarInmueble = true;
    this.detalle = new DetalleInmuebleModel();
    this.detalleExiste = false;
    this.mapaCargado = false;
    this.getDetalleInmueble();
    window.scrollTo(0, 0);
    setTimeout(() => {
      // @ts-ignore
      this.moverCarrusel(1);
      //this.lblBtnCerrarModal = this.CANCELAR;
      //this.mostrarFormRecomendarInmueble = true;
    }, 6000);
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
    console.log('ShareModal:', this.shareModal);
    console.log('RecomendarModal:', this.recomendarModal);
  }

  obtenerIndiceGlobal(grupoIndex: number, imagenIndex: number): number {
    const imagenesPorGrupo = this.gruposImagenes[0]?.length || 0;
    return grupoIndex * imagenesPorGrupo + imagenIndex;
  }

  crearFormRecomendar() {
    // @ts-ignore
    this.formRecomendar = this.formBuilder.group({
      remitente: ['', [Validators.required, this.nombreValido()]],
      apellido1: ['', [Validators.required, this.nombreValido()]],
      apellido2: ['', this.nombreValido()],
      destinatario: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')]],
      mensaje: ['']
    });
  }

  private nombreValido() {
    return (control: UntypedFormControl): { [key: string]: any } | null => {
      const valor: string = (control.value || '').trim();

      if (!valor) {
        return null;
      }

      if (valor.length < 2 || valor.length > 50) {
        return { longitud: true };
      }

      if (valor.length === 2 && valor[0].toLowerCase() === valor[1].toLowerCase()) {
        return { repetidos: true };
      }

      return null;
    };
  }

  recomendarAUnAmigo() {
    //mostrar modal como enviando mail
    this.confModCargando();
    //this.mostrarFormRecomendarInmueble = false;
    //se caraga la informacion al objeto que será enviado al servicio
    this.crearPayLoadRecomendarInmueble();
    //this.mostrarBtnCerrarModal = false;
    this.recomendarService.recomendarAUnAmigo(this.recomendarDto).subscribe( data => {
      //respuesta desde el servicio
      if (data.mensaje == "OK") {
        this.confModExito();
        this.cerrarModalRecomendar();
        this.openModalExitoso();
      }
      //this.lblBtnCerrarModal = this.ACEPTAR;
      //this.mostrarBtnCerrarModal = true;
    }, error => {
      this.cerrarModalRecomendar();
      //this.lblBtnCerrarModal = this.ACEPTAR;
      //this.mostrarBtnCerrarModal = true;
    });
  }

  openModalExitoso(): void {
    const dialogRef = this.dialog.open(OpExitosaModalComponent, {
      panelClass: 'modal-exitoso',
      autoFocus: false,
      disableClose: true,
      data: {
        titulo: '¡Formulario enviado con éxito!',
        mensaje: 'En breve, la persona con la que compartiste el inmueble recibirá un correo electrónico con la información correspondiente.'
      }
    });

    document.body.classList.add('disable-scroll');

    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('disable-scroll');
    });
  }

  getWhatsappUrl(detalle: any): string {
    const text = `Hola este inmueble te puede interesar /banorte/__host/inmuebles/Inmuebles#/detalle/${detalle.folio}`;
    return 'https://wa.me/?text=' + encodeURIComponent(text);
  }

  crearPayLoadRecomendarInmueble() {
    // @ts-ignore
    this.recomendarDto.destinatario = this.formRecomendar.get("destinatario").value;
    // @ts-ignore
    this.recomendarDto.remitente = this.formRecomendar.get("remitente").value;
    this.recomendarDto.apellido1 = this.formRecomendar.get("apellido1").value;
    this.recomendarDto.apellido2 = this.formRecomendar.get("apellido2").value;
    this.recomendarDto.folio = this.detalle.folio;
    // @ts-ignore
    this.recomendarDto.mensaje = this.formRecomendar.get("mensaje").value;

    this.recomendarDto.nombreContacto = this.detalle.nombreGerente;
    this.recomendarDto.correoContacto = this.detalle.emailGerente;
  }

  formularioRecomendarInmuebleEsValido(): boolean {
    // @ts-ignore
    if(this.formRecomendar.invalid) {
      // @ts-ignore
      Object.values(this.formRecomendar.controls).forEach( control => {
        // @ts-ignore
        control.markAsTouched();
      });
      return false;
    }
    return true;
  }

  abrirModalRecomendarInmueble() {
    //this.mostrarFormRecomendarInmueble = true;
  }

  cerrarModalRecomendar() {
    setTimeout(() => {
      // @ts-ignore
      this.formRecomendar.reset();
      //this.lblBtnCerrarModal = this.CANCELAR;
      //this.mostrarFormRecomendarInmueble = true;
    }, 100);
  }

  verificarImagen(event: Event, fallback: string) {
    const img = event.target as HTMLImageElement;
    console.log(img.naturalWidth);
    console.log(img.naturalHeight);
    if (img.naturalWidth === 0 || img.naturalHeight === 0) {
      img.src = fallback;
    }
  }

  /**
   * funcion para obtener detalle de inmueble desde el back
   */
  getDetalleInmueble() {
    this.cargandoDet();
    this.listo = false;
    this.activatedRoute.params.subscribe( params => {
      //se obtiene el parametro 'folio' que viene por URL
      this.folio = params['folio'];
      this.detalleService.getDetalleInmueble(this.folio).subscribe( data => {
        if (data.inmueble != null) {
          this.setData(data.inmueble);
          this.imagenes = data.imagenes;
          this.gruposImagenes = this.agruparImagenes(this.imagenes, 3);
          this.album = this.imagenes.map((img) => ({
            src: img,
            thumb: img
          }));
          this.getGeolocation(this.direccion);
          this.detalleExiste = true;
          this.listo = true;
        } else {
          this.noSeEncontroDet();
          this.detalleExiste = false;
        }
      },error => {
        this.error = true;
        this.listo = true;
        /* this.errorDet();
        this.listo = true;
         this.imagenes = ['https://images.adsttc.com/media/images/5f28/18e2/b357/653d/3a00/0f56/large_jpg/OH357_CasadelAgua_DifrennaArquitectos_ALTA-7305063.jpg?1596463297',
          'https://tse1.mm.bing.net/th/id/OIP.9cCO5VYOf_U9PkPByIROwwHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
          'https://focalizando.com.br/sites/default/files/inline-images/fotos%20de%20casa%2014.jpg',
          'https://focalizando.com.br/sites/default/files/inline-images/fachadas-de-casas-modernas-128-768x768.webp',
          'https://th.bing.com/th/id/R.713ec62da3750fc53836a5a13281ebbe?rik=ATm%2bX1c3Qi7OOA&pid=ImgRaw&r=0',
        ];
        this.gruposImagenes = this.agruparImagenes(this.imagenes, 3);
        this.album = this.imagenes.map((img) => ({
          src: img,
          thumb: img
        })); */
      })
    })
  }

  /**
   * Función para obtener latitud y longitud de una direccion
   * @param direccion de la cual se quire obtener la localización
   */
  getGeolocation(direccion: string) {
    this.cargandoMap();
    this.detalleService.getLocation(this.removeAccents(direccion)).subscribe( data => {
      //console.log(data);
      this.lat = data.lat;
      this.lng = data.lng;
      this.mapaCargado = true;
      this.center = { lat: this.lat, lng: this.lng };
    },error => {
      this.errorMap();
      //console.log(error);
    })
  }

  removeAccents(str: string): string {
    return str.replace("Á","A")
      .replace("á","a")
      .replace("É","E")
      .replace("é","e")
      .replace("Í","I")
      .replace("í","i")
      .replace("Ó","O")
      .replace("ó","o")
      .replace("Ú","U")
      .replace("ú","u")
      .replace("Ñ","N")
      .replace("ñ","n");
  }

  /**
   * Función para asiganr la data del detalle del inmueble al objeto tipo Detalle
   * @param data objeto que regresa el back al buscar el detalle de un Inmueble
   */
  setData( data: any) {
    this.direccion = `${ data.colonia}, ${data.idCiudad.nombre}, ${data.idCiudad.idEstado.nombre}.`;
    this.detalle.ciudad = data.idCiudad.nombre;
    this.detalle.direccion = `${data.calle}, ${ data.colonia}, ${data.idCiudad.nombre}, ${data.idCiudad.idEstado.nombre}.`;
    this.detalle.estado = data.idCiudad.idEstado.nombre;
    //this.detalle.estatus = data.status;
    this.detalle.estatus = (data.comercializable)?'1':'0';
    this.detalle.comercializable = data.comercializable;
    this.detalle.folio = data.folio;
    this.detalle.m2Construccion = data.metrosConstruccion;
    this.detalle.m2Terreno = data.metrosTerreno;
    this.detalle.precio = data.precio;
    this.detalle.tipoInmueble = data.idTipoInmueble.nombre;
    this.detalle.descripcion = data.descripcion;
    this.detalle.emailGerente = data.idPromotor.gerenteEntity.email;
    this.detalle.nombreGerente = data.idPromotor.gerenteEntity.nombre;
    this.detalle.promotor = data.idPromotor;
    this.detalle.inmueble = data;
    this.detalle.subtipo = data.idSubtipoInmueble.nombre;
  }

  /**
   * funciones para asignar mensajes de error que se muestran en pantalla
   */
  cargandoDet() {
    this.detalleError.cabecera = 'Cargando...';
    this.detalleError.mensaje = '';
  }
  noSeEncontroDet() {
    this.detalleError.cabecera = `No se encontró un Inmueble con el folio: ${ this.folio}`;
    this.detalleError.mensaje = 'No se encontró registro del inmueble que intenta buscar, favor de revisar el folio.';
  }
  errorDet() {
    this.detalleError.cabecera = 'ERROR 500';
    this.detalleError.mensaje = 'No se puede establecer comunicación con el servidor, intente más tarde por favor.';
  }
  cargandoMap() {
    this.mapError.cabecera = 'Cargando...';
    this.mapError.mensaje = 'Buscando la dirección del inmueble...';
  }
  errorMap() {
    this.mapError.cabecera = 'Error';
    this.mapError.mensaje = 'No se pudo conectar con Google Maps.';
  }

  /*
 Get para obtener el estado de la propiedad 'correo'
  */
  get destinatarioInvalido() {
    // @ts-ignore
    return this.formRecomendar.get('destinatario').invalid && this.formRecomendar.get('destinatario').touched;
  }
  /*
Get para obtener el estado de la propiedad 'correo'
*/
  get remitenteInvalido() {
    // @ts-ignore
    return this.formRecomendar.get('remitente').invalid && this.formRecomendar.get('remitente').touched;
  }

  /*
Configuracion para modal caza oportunidad cuando este está en modo 'cargando'
 */
  confModCargando() {
    this.confModalRecomendar.colorLogo = this.validadores.modalOptios.icono.cargando.color;
    this.confModalRecomendar.logo = this.validadores.modalOptios.icono.cargando.logo;
    this.confModalRecomendar.mensajeFooter = this.validadores.modalOptios.mensaje.cargando.footer;
    this.confModalRecomendar.mensajeHeader = this.validadores.modalOptios.mensaje.cargando.header;
  }
  /*
  Configuracion para modal caza oportunidad cuando ocurre un 'error'
   */
  confModError() {
    this.confModalRecomendar.colorLogo = this.validadores.modalOptios.icono.error.color;
    this.confModalRecomendar.logo = this.validadores.modalOptios.icono.error.logo;
    this.confModalRecomendar.mensajeFooter = this.validadores.modalOptios.mensaje.error.footer;
    this.confModalRecomendar.mensajeHeader = this.validadores.modalOptios.mensaje.error.header;
  }
  /*
  Configuracion para modal caza oportunidad cuando la acción se realiza con 'exito'
   */
  confModExito() {
    this.confModalRecomendar.colorLogo = this.validadores.modalOptios.icono.exito.color;
    this.confModalRecomendar.logo = this.validadores.modalOptios.icono.exito.logo;
    this.confModalRecomendar.mensajeFooter = this.validadores.modalOptios.mensaje.exito.footer;
    this.confModalRecomendar.mensajeHeader = this.validadores.modalOptios.mensaje.exito.header;
  }

  guardarNotificacion() {
    //console.log(this.formNotificacion);
    if (!this.formularioNotificacionValido()) {
      return;
    }
    this.configuracionModalCargando();
    this.procesandoNotificacion = true;
    //console.log('Enviando peticion');
    this.crearPayLoadNotificacion();
    this.lblBtnCerrarModal = this.ACEPTAR;
    this.detalleService.saveNotificacionInmueble(this.payLoadNotificacion).subscribe((data: InmuebleResponse) => {
      //console.log(data);
      //console.log(data.mensaje);
      if (data.codError === this.CODERROR) {
        this.notificacionFallida = true;
        this.configuracionModalErrorMessage(data.respuesta);
        this.procesandoNotificacion = false;
      } else if (data.mensaje === this.OK) {
        this.notificacionGuardada = true;
        this.configuracionModalExito();
        this.procesandoNotificacion = false;
        this.notificacionModel = new NotificacionInmueble();
      } else {
        this.notificacionFallida = true;
        this.configuracionModalError();
        this.procesandoNotificacion = false;
      }
    }, error => {
      //console.log(error);
      this.notificacionFallida = true;
      this.configuracionModalError();
      this.procesandoNotificacion = false;
    });
  }

  formularioNotificacionValido(): boolean {
    // @ts-ignore
    if (this.formNotificacion.invalid) {
      // @ts-ignore
      Object.values(this.formNotificacion.controls).forEach(control => {
        // @ts-ignore
        control.markAsTouched();
        // @ts-ignore
        if (control.errors.hasOwnProperty('pattern')) {
          this.mensajeValidacionEmail = 'Correo no válido';
        } else {
          this.mensajeValidacionEmail = 'Ingresa tu correo electrónico';
        }
      });
      return false;
    }
    return true;
  }

  obtenerFichaTecnica() {
    console.log("ficha tecnica...");
    this.cargandoFicha = true;
    this.detalleService.getFichaTecnica(this.detalle.folio).subscribe( response => {
      saveAs(response.body, response.filename);
      this.cargandoFicha = false;
    });
  }

  configuracionModalCargando() {
    this.confModal.colorLogo = this.validarores.modalOptios.icono.cargando.color;
    this.confModal.logo = this.validarores.modalOptios.icono.cargando.logo;
    this.confModal.mensajeFooter = this.validarores.modalOptios.mensaje.cargando.footer;
    this.confModal.mensajeHeader = this.validarores.modalOptios.mensaje.cargando.header;
  }

  configuracionModalError() {
    this.confModal.colorLogo = this.validarores.modalOptios.icono.error.color;
    this.confModal.logo = this.validarores.modalOptios.icono.error.logo;
    this.confModal.mensajeFooter = this.validarores.modalOptios.mensaje.error.footer;
    this.confModal.mensajeHeader = this.validarores.modalOptios.mensaje.error.header;
  }

  configuracionModalErrorMessage(texto: string) {
    this.confModal.colorLogo = this.validarores.modalOptios.icono.error.color;
    this.confModal.logo = this.validarores.modalOptios.icono.error.logo;
    this.confModal.mensajeFooter = texto;
    this.confModal.mensajeHeader = this.validarores.modalOptios.mensaje.error.header;
  }

  configuracionModalExito() {
    this.confModal.colorLogo = this.validarores.modalOptios.icono.exito.color;
    this.confModal.logo = this.validarores.modalOptios.icono.exito.logo;
    this.confModal.mensajeFooter = this.validarores.modalOptios.mensaje.exito.footer;
    this.confModal.mensajeHeader = this.validarores.modalOptios.mensaje.exito.header;
  }

  crearPayLoadNotificacion() {
    // @ts-ignore
    this.payLoadNotificacion.email = this.formNotificacion.get('correo').value;
    this.payLoadNotificacion.folio = this.folio;
  }

  get correoInvalido() {
    // @ts-ignore
    return this.formNotificacion.get('correo').invalid && this.formNotificacion.get('correo').touched;
  }

  cerrarModalNotificacion() {
    setTimeout(() => {
      // @ts-ignore
      this.formNotificacion.reset();
      this.mensajeValidacionEmail = '';
      this.notificacionGuardada = false;
      this.notificacionFallida = false;
      this.procesandoNotificacion = false;
      this.lblBtnCerrarModal = this.CANCELAR;
    }, 1000);
    const modalRecomendar = new bootstrap.Modal(this.recomendarModal.nativeElement);
    modalRecomendar.hide();
  }

  crearFormularioNotificacion() {
    // @ts-ignore
    this.formNotificacion = this.formBuilder.group({
      correo: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')], '']
    });
  }

  abrirShareModal() {
    const modal = new bootstrap.Modal(this.shareModal.nativeElement);
    modal.show();
  }
  
  cambiarModal() {
      const modalCompartir = bootstrap.Modal.getInstance(this.shareModal.nativeElement);
      if (modalCompartir) {
        console.log('Cerrando modal compartir');
        modalCompartir.hide();
      }

      setTimeout(() => {
        console.log('Abriendo modal recomendar');
        const modalRecomendar = new bootstrap.Modal(this.recomendarModal.nativeElement);
        modalRecomendar.show();
        setTimeout(() => {
          document.body.classList.add('modal-open');
        }, 50);
      }, 300);
  }

  obtenerUltimosCinco(valor: string): string {
    const partes = valor.split('-');
    const ultimoSegmento = partes[partes.length - 1];
    return ultimoSegmento.slice(-5);
  }

  agruparImagenes(imagenes: string[], cantidad: number): string[][] {
    const grupos = [];
    for (let i = 0; i < imagenes.length; i += cantidad) {
      grupos.push(imagenes.slice(i, i + cantidad));
    }
    return grupos;
  }

  moverCarrusel(direccion: number) {
    const el = document.querySelector('#carouselInmuebles');
    if (el) {
      const carousel = bootstrap.Carousel.getInstance(el) || new bootstrap.Carousel(el);
      direccion === -1 ? carousel.prev() : carousel.next();
    }
  }

  abrirGaleria(index: number): void {
    this.lightbox.open(this.album, index);
    // Bloqueamos clics al fondo agregando el div
    const blocker = document.createElement('div');
    blocker.classList.add('backdrop-blocker');
    document.body.classList.add('disable-scroll');
    blocker.setAttribute('id', 'lightbox-blocker');
    document.body.appendChild(blocker);

    // Opcional: observar cuándo se cierra la galería
    const interval = setInterval(() => {
      const overlay = document.querySelector('.lightboxOverlay');
      if (!overlay) {
        const existing = document.getElementById('lightbox-blocker');
        if (existing) {
          existing.remove();
          document.body.classList.remove('disable-scroll');
        }
        clearInterval(interval);
      }
    }, 300);
  }

  cerrarGaleria(): void {
    this.lightbox.close();
  }

  public capitalizeFirstLetter = (texto: string): string => {
    if (!texto) return '';
    return texto
      .toLowerCase()
      .split(' ')
      .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
      .join(' ');
  }
}